import React, { useState, useEffect } from "react";

import { FiMinus } from "react-icons/fi";
import { IoIosAdd } from "react-icons/io";

import { FaPencilAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { StateType } from "../../store/Reducer/index.reducer";
import { getCart, handleDelete, handleUpdateCart } from "../../store/api/cart";

import { CartType } from "../../store/Type/cart.type";
import Empty from "../Empty";
import { Modal } from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import { displayLoader } from "../../store/Action/loader.action";
import Pricing from "../Pricing";
import text_truncate from "../TextTruncate";
import { ApiCreateOrder } from "../../store/api/order";
import { CartReducar } from "../../store/Reducer/cart.reducer";
import AppButton from "../AppButton";
import { useTranslation } from "react-i18next";

interface Props {
    disabledButton?: boolean;
    cart: CartReducar;
    tablenum: string | number | null;
    inputName: string;
    phonenum: any;
}
const Index = ({
    disabledButton,
    cart,
    tablenum,
    inputName,
    phonenum,
}: Props) => {
    const { t } = useTranslation("order");
    const { currentVenue, zone } = useParams();
    const [clicked, setClicked] = useState(false);
    const dispatch = useDispatch<any>();
    let navigate = useNavigate();
    const [note, setNote] = useState("");
    const [isModalVisible, setIsModalVisible] = useState({
        status: false,
        productId: "",
        productKey: "",
    });

    const [formData, setFormData] = useState({
        kitchen_note: "",
    });

    const handleOk = async (productId: string, productKey: string) => {
        await dispatch(handleDelete(productId, productKey));
        dispatch(getCart());
        setIsModalVisible({ status: false, productId: "", productKey: "" });
    };

    const handleCancel = () => {
        setIsModalVisible({ status: false, productId: "", productKey: "" });
    };

    const { product: Product, totalQty } = cart;
    const currency = useSelector(
        (state: StateType) => state.category?.categoryRes?.currency
    );

    const updateQuantity = (
        productId: string,
        quantity: number,
        productKey: string,
        zone: any
    ) => {
        let data = {
            productId,
            quantity,
            productKey,
            zone,
        };
        setClicked(true);

        dispatch(displayLoader(true));
        if (quantity < 1) {
            setIsModalVisible({ status: true, productId, productKey });
            dispatch(displayLoader(false));
        } else {
            dispatch(displayLoader(true));
            dispatch(handleUpdateCart(data));
        }
    };

    const handleConfirm = () => {
        const data: any = {
            zone: zone,
            table: tablenum,
            name: inputName,
            kitchen_note: note,
            phone: phonenum,
        };
        tablenum &&
            dispatch(
                ApiCreateOrder(data, { currentVenue, zone, navigate: navigate })
            );
        dispatch(displayLoader(true));
        localStorage.removeItem("session_id");
    };
    return (
        <>
            {totalQty > 0 ? (
                <div
                    className={
                        zone == "guest-request"
                            ? "table-wrapper guest_tablewrapper"
                            : "table-wrapper"
                    }
                >
                    {Product?.map((item: CartType, index: number) => {
                        return (
                            <>
                                <div className="table-container" key={index}>
                                    <div className="table__left">
                                        <h4>
                                            {text_truncate({
                                                str: item.name,
                                                length: 25,
                                                ending: null,
                                            })}
                                        </h4>
                                        <div className="tabletopping__wrapper">
                                            {Array.isArray(item.topping) &&
                                                item?.topping?.map(
                                                    (data, i) => {
                                                        return (
                                                            <>
                                                                <div
                                                                    className="table_topping"
                                                                    key={i}
                                                                >
                                                                    <span>
                                                                        {
                                                                            data.name
                                                                        }
                                                                    </span>
                                                                    <span>
                                                                        +
                                                                        {
                                                                            data.price
                                                                        }
                                                                    </span>
                                                                </div>
                                                            </>
                                                        );
                                                    }
                                                )}
                                        </div>
                                        <div className="item__total-price">
                                            {zone == "guest-request" ? (
                                                "Free"
                                            ) : (
                                                <>
                                                    {currency?.replace(
                                                        /-/g,
                                                        " "
                                                    )}
                                                    &nbsp;
                                                    {item.unitPrice}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className="table__right">
                                        <div
                                            className={`inc-dec ${
                                                clicked ? "clicked" : ""
                                            }`}
                                            onTouchStart={() =>
                                                setClicked(true)
                                            }
                                            onClick={() => {
                                                setClicked(true);
                                                +item.quantity > 0 &&
                                                    updateQuantity(
                                                        item.productId,
                                                        +item.quantity - 1,
                                                        item.productKey,
                                                        zone
                                                    );
                                            }}
                                        >
                                            <FiMinus />
                                        </div>
                                        <div className="inc-dec__num">
                                            {item.quantity}
                                        </div>
                                        <div
                                            className="inc-dec"
                                            onClick={() =>
                                                updateQuantity(
                                                    item.productId,
                                                    +item.quantity + 1,
                                                    item.productKey,
                                                    zone
                                                )
                                            }
                                        >
                                            <IoIosAdd />
                                        </div>
                                    </div>
                                </div>
                            </>
                        );
                    })}
                    <div className="table-button">
                        <Link
                            className="additem_link"
                            to={`/menu/${currentVenue}/${zone}/category`}
                        >
                            <button>
                                <IoIosAdd className="add-icon" />
                                {t("default:common.buttons.addItem")}
                            </button>
                        </Link>
                    </div>
                    <div className="kitchen_note">
                        <div className="kitchen_noteleft">
                            <img src="/Images/Icon.svg" alt="note-icon" />
                            {t("addNotes")}
                        </div>

                        <div className="notebox">
                            <textarea
                                placeholder={`${t("writeSomething")}`}
                                value={note}
                                name="note"
                                onChange={(e) => setNote(e.target.value)}
                            ></textarea>
                        </div>
                    </div>
                    {/* <div className="voucher-content">
                        <div className="voucher-content-left">
                            <BsFillTagsFill className="filltag" /> Add voucher
                            or discount code
                        </div>
                        <BiChevronRight className="table__right-arrow" />
                    </div> */}

                    <div className="ordertable_footer">
                        {zone != "guest-request" && <Pricing />}
                        <AppButton
                            btnType="tertiary"
                            onClick={handleConfirm}
                            disabled={disabledButton ? true : false}
                            className={
                                disabledButton
                                    ? "continuebtn"
                                    : "continuebtnactive"
                            }
                        >
                            {zone == "guest-request"
                                ? t("default:common.buttons.confirmRequest")
                                : t("default:common.buttons.confirm")}
                        </AppButton>
                    </div>
                </div>
            ) : (
                <Empty />
            )}

            <Modal
                className="remove_modal"
                title="Remove Item?"
                visible={isModalVisible.status}
                onCancel={handleCancel}
            >
                <p>Are you sure you want to remove this order ?</p>
                <div className="removemodal_footer">
                    <button onClick={handleCancel}>Cancel</button>
                    <button
                        onClick={() =>
                            handleOk(
                                isModalVisible.productId,
                                isModalVisible.productKey
                            )
                        }
                    >
                        Remove
                    </button>
                </div>
            </Modal>
        </>
    );
};

export default Index;
